import React, { useRef, useEffect } from 'react';
import { Toast } from 'primereact/toast';
import { ModalInstall } from './ModalInstall';
import { Header } from './Header';

export const PostLoginWrapper = ({ children, error, isMain, isField, fieldId, field, isCreateField, stepIndex, prevStep, isNotifications, isEditField, loading }) => {
    const toast = useRef(null);
    useEffect(() => {
        if (error) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: error, life: 6000 });
        }
    }, [error]);

    return (
        <>
            <ModalInstall />
            <div className="flex flex-column align-items-center w-full" style={{ height: '100vh' }}>
                <div className="flex flex-column align-items-center w-full mobile-max-width">
                    <Toast ref={toast} position="top-center" className="w-11" />
                    <Header
                        isMain={isMain}
                        isNotifications={isNotifications}
                        isField={isField}
                        fieldId={fieldId}
                        field={field}
                        isCreateField={isCreateField}
                        stepIndex={stepIndex}
                        prevStep={prevStep}
                        isEditField={isEditField}
                        loading={loading}
                    />
                    {children}  {/* Aquí se renderiza el contenido adicional */}
                </div>
            </div>
        </>
    );
};
